import { useEffect } from 'react';

const CARD_SELECTOR = '[data-issue-card="true"]';

/**
 * Навигация по карточкам клавишами ←/→ (docs/06 §3.1): перемещает фокус между
 * ближайшими карточками в DOM-порядке. `Space` и `Esc` обрабатывает KeyboardSensor
 * из @dnd-kit — здесь они не перехватываются.
 */
export function useBoardKeyboardNav(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        return;
      }
      const active = document.activeElement;
      if (!(active instanceof HTMLElement) || !active.matches(CARD_SELECTOR)) {
        return;
      }
      const cards = [...document.querySelectorAll<HTMLElement>(CARD_SELECTOR)];
      const index = cards.indexOf(active);
      if (index < 0) {
        return;
      }
      const next = cards[index + (event.key === 'ArrowRight' ? 1 : -1)];
      if (!next) {
        return;
      }
      event.preventDefault();
      next.focus();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [enabled]);
}
